// Return the first year (on the x-axis) from an array of ChartLine objects
export var getFirstYear = function (data) {
  var _a, _b;
  return ((_b = (_a = data[0]) === null || _a === void 0 ? void 0 : _a.data[0]) === null || _b === void 0 ? void 0 : _b.x) ? new Date(data[0].data[0].x).getFullYear() : '';
};
// Return the last year (on the x-axis) from an array of ChartLine objects
export var getLastYear = function (data) {
  var _a, _b;
  return ((_b = (_a = data[0]) === null || _a === void 0 ? void 0 : _a.data[0]) === null || _b === void 0 ? void 0 : _b.x) ? new Date(data[0].data[data[0].data.length - 1].x).getFullYear() : '';
};